var _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavMenuClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.21777,
    y: 0.892578,
    width: 12,
    height: 3,
    rx: 1.5,
    transform: "rotate(46.0295 3.21777 0.892578)",
    fill: "#353B7D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.954102,
    y: 17.8759,
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "rotate(-45 0.954102 17.8759)",
    fill: "#353B7D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.27002,
    y: 7.18591,
    width: 15,
    height: 3,
    rx: 1.5,
    transform: "rotate(46.3307 9.27002 7.18591)",
    fill: "#353B7D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMenuClose);
export default __webpack_public_path__ + "static/media/nav-menu-close.5f5bf44a9a7512287d5e524e0efd9f95.svg";
export { ForwardRef as ReactComponent };